import { APP_CHECK_DISABLED, MSS_CODE } from './constant.mjs';

const isAppCheckDisabled = () => {
  return typeof window === 'undefined' ? false : window.localStorage.getItem(APP_CHECK_DISABLED) === 'true';
};
function generateMSSCode(param) {
  return Object.entries(param).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return value ? acc + MSS_CODE[key] : acc;
  }, 0);
}

export { generateMSSCode, isAppCheckDisabled };
